import React, { Component } from 'react';
import { withStyles } 		from 'material-ui/styles';
import Button 				from 'material-ui/Button';
import Icon 				from 'material-ui/Icon';
import { Link } 			from 'react-router-dom'

const styles = {
    navLink: {

    },

};

class Navigation extends Component {
  classes = this.props.classes;
  render() {
    return (
      <Button component={Link} to={this.props.path} color="primary" className={this.classes.navLink}>
        <Icon color="primary">{this.props.icon}</Icon> {this.props.name}
      </Button>
    );
  }

}

export default withStyles(styles)(Navigation);



// WEBPACK FOOTER //
// ./src/components/navigation/NavLink.js